export default "__VITE_ASSET__mghefaJR__"